<div class="listwrapper col gap-8 w100">
    <div class="w100 card col gap-8" *ngFor="let activity of activityList">
        <div class="row space-between w100">
            <div class="col gap-4">
                <div class="row gap-24 align-center">
                    <h4 class="strong">{{ activity.processingPurpose }}</h4>
                    <div class="row gap-8">
                        <!-- <rr-badge tone="success">{{
                            activity.status
                        }}</rr-badge> -->
                        <rr-badge tone="info">{{
                            activity.legalBasis
                        }}</rr-badge>
                        @if( activity.isCriminalData === true ){
                        <rr-badge tone="error">strafrechtliche Daten</rr-badge>
                        }@else {
                        <rr-badge tone="success">
                            keine strafrechtlichen Daten</rr-badge
                        >
                        } @if( activity.isSpecialCategory === true ){
                        <rr-badge tone="error">Besondere Kategorie</rr-badge>
                        }@else {
                        <rr-badge tone="success">Standard Kategorie</rr-badge>
                        }

                        <rr-badge tone="warning">{{
                            activity.isRegularProcessing
                                ? "regelmäßige Verarbeitung"
                                : "nicht regelmäßige Verarbeitung"
                        }}</rr-badge>
                    </div>
                </div>
                <div class="row gap-8 tiny">
                    <span>status: {{ activity.status }}</span>
                    <span *ngIf="activity.createdAt">|</span>
                    <span *ngIf="activity.createdAt"
                        >created: {{ activity.createdAt | date }}</span
                    >
                    <span *ngIf="activity.updatedAt">|</span>
                    <span *ngIf="activity.updatedAt"
                        >updated: {{ activity.updatedAt | date }}</span
                    >
                </div>
            </div>
            <div class="row gap-8 align-center">
                <rr-btn
                    size="Small"
                    type="Link"
                    (click)="deleteActivity(activity.id || '')"
                    >delete</rr-btn
                >
                <rr-btn
                    iconStart="edit"
                    size="Small"
                    type="Secondary"
                    (click)="activity.id ? editActivity(activity.id) : null"
                    >Edit</rr-btn
                >
            </div>
        </div>
        <rr-divider></rr-divider>
        <div class="w100 row gap-8 space-between">
            <div class="row gap-4">
                <rr-badge *ngFor="let cat of activity.dataCategories">{{
                    cat | getCategoryNameById
                }}</rr-badge>
            </div>
        </div>
    </div>
</div>
@if(isLoading === true){
<rr-spinner></rr-spinner>
}
